{
  "password": {
    "show": "Show password",
    "hide": "Hide password",
    "rule": "At least 8 characters. A short sentence is easy to remember and hard to guess."
  },
  "promise": {
    "title": "Know exactly what you have, where it is, and how it got there.",
    "recorded": {
      "title": "Every movement is recorded",
      "text": "Stock only changes through validated operations, so every number can be explained."
    },
    "locations": {
      "title": "All your locations in one place",
      "text": "Warehouses, stores and stock in transit, side by side."
    },
    "alerts": {
      "title": "Warned before it is too late",
      "text": "Low, out and negative stock alerts reach the right people."
    }
  },
  "fields": {
    "username": "Username",
    "usernamePlaceholder": "e.g. amira",
    "password": "Password",
    "identifier": "Username or email",
    "newPassword": "New password",
    "confirmPassword": "Repeat the new password",
    "currentPassword": "Current password"
  },
  "signIn": {
    "title": "Welcome back",
    "subtitle": "Sign in to manage your stock.",
    "sessionEnded": "Your session closed after {{minutes}} minutes without activity. Sign in again to continue.",
    "passwordReset": "Your password has been changed. Sign in with your new password.",
    "forgot": "Forgot password?",
    "submit": "Sign in",
    "securityNote": "For your security, the account is locked for {{lockout}} minutes after {{attempts}} wrong passwords. Sessions close after {{idle}} minutes without activity.",
    "noAccount": "No account yet? Ask your administrator to create one for you.",
    "restored": "The data was restored from a backup: sign in again."
  },
  "forgot": {
    "back": "Back to sign in",
    "title": "Forgot your password?",
    "subtitle": "We will email you a link to choose a new one.",
    "hint": "The email goes to the address saved on your account. No email on your account? Ask your administrator to reset your password.",
    "submit": "Send me a link",
    "sentTitle": "Check your email",
    "sentText": "If an account matches, a link is on its way. It works once and expires after one hour."
  },
  "reset": {
    "title": "Choose a new password",
    "subtitle": "You will sign in with it from now on. Your other sessions will be closed.",
    "invalidTitle": "This link is not valid or has expired.",
    "requestAgain": "Ask for a new link",
    "submit": "Save my new password"
  },
  "change": {
    "done": "Your password has been changed.",
    "submit": "Change password",
    "submitAndContinue": "Save and continue",
    "requiredTitle": "Welcome, {{name}}",
    "requiredSubtitle": "Choose your own password before you start.",
    "requiredNotice": "You signed in with a temporary password. Replace it with one only you know."
  }
}
